import { apiFetch } from "../fetchApi";

export const fetchCreate = async (BeURL, showAlert, formData, formData1) => {
    try {

        // 1️⃣ Try organisation creation
        const orgRes = await apiFetch(`${BeURL}/create-organisation`, {
            method: "POST",
            body: formData,
        });

        const orgData = await orgRes.json();

        //  If organisation exists or creation failed → stop
        if (!orgData.success) {
            showAlert(orgData.message);
            return;
        }

        //  Organisation created, proceed to user creation
        const companyId = orgData.company;
        // showAlert(orgData.message);

        // 2️ Create User
        const accountRes = await apiFetch(`${BeURL}/create-account?id=${companyId}`, {
            method: "POST",
            body: formData1
        });

        const accountData = await accountRes.json();

        //  If user duplicate → stop but do NOT recreate organisation
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }
        else{
            window.location.href="/"
        }

        //  User Created Successfully
        showAlert(accountData.message);

    } catch (err) {
        console.error(err);
        alert("Server error");
    }
};



export const fetchOrganisation = async (BeURL, showAlert, setOrganisation, companyId) => {
    try {

        const res = await apiFetch(`${BeURL}/fetch-organisations/${companyId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setOrganisation(data.organisation)

    }
    catch (err) {
        console.error("Error in Organisation fetch:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }

}